import {Injectable} from "@angular/core";
import {MvsObjectNavigationService} from "./mvs-object-navigation.service";

@Injectable({providedIn: 'root'})
export class AlphaObjectNavigationService extends MvsObjectNavigationService {

}
